(ns arthur.demo
  "The hand-written clip from port-plan step 2, and nothing else.

  The EDN is a resource rather than a literal in this file so that the test and
  the page read the SAME bytes. If the scene were written twice, the one the test
  validates would not be the one that renders, and the model would be validated
  against a scene nobody ever looked at."
  (:require [arthur.domain.clip :as domain-clip]
            [arthur.domain.palette :as pal]
            [arthur.domain.symbol :as symbol]
            [cljs.reader :as reader]
            [shadow.resource :as rc]))

(def source (rc/inline "arthur/demo/scene.edn"))

(def clip (reader/read-string source))

(def main
  "The scene's one symbol: what an evaluator takes. `clip` is the document."
  (domain-clip/symbol clip :main))

(def fps (:fps clip))
(def frames (domain-clip/frames clip :main))

(defn ops-at
  "Draw ops for one frame, via the specification path. The page uses
  `symbol/resolver` instead; this is here for the REPL."
  [f]
  (symbol/eval-frame main f nil pal/index-of nil))
